export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11077.842e8019.jpg";